export enum LocationRouteEndpoints {
  ADD_NEW = 'add-new',
  EDIT = 'edit'
}
